import React from "react";
import { Route, Routes } from "react-router-dom";
// import BankAccounts from "./Banks/BankAccounts";
// import Cheque from "./Cheque";
// import LoanAccounts from "./LoanAccounts";
import BankAccountsAllEffected from "./BankAccounts/BankAccountsAllEffected";
import BankReconciliation from "./BankReconciliation/BankReconciliation";
import Cheque from "./Cheque/Cheque";
import ResourceNotFound from "../../Common/ResourceNotFound";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import CashInHandAllEffected from "./CashInHand/CashInHandAllEffected";

const BankingNestedRoute: React.FC = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();
  return (
    <Routes>
      <Route>
        <Route
          path="/bankAccounts"
          element={
            findUserPremission(
              ["Voucher.Contra.13.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Contra],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <BankAccountsAllEffected />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/cashInHand"
          element={
            findUserPremission(
              ["Voucher.Contra.13.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Contra],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <CashInHandAllEffected />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/cheque"
          element={
            findUserOnlyOnePremission(
              "Master.Cheque.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <Cheque />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route
          path="/loanAccounts"
          element={
            findUserOnlyOnePremission(
              "Master.LoanAccounts.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <LoanAccounts />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        /> */}
        <Route
          path="/bankReconciliation"
          element={
            findUserOnlyOnePremission(
              "Master.BankReconciliation.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <BankReconciliation />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
      </Route>
    </Routes>
  );
};
export default BankingNestedRoute;
